import styled from 'styled-components';
import { ReactComponent as Logo } from '../../logo.svg';

const CustomHeader = styled.div`
	background: #232F3E;
	padding: 5px 10px 0 10px;
`;

function HeaderName() {
	return (
		<>
			<CustomHeader><Logo /></CustomHeader>
			<hr />
		</>
	);
}

export default HeaderName;
